import script from "./OrderBookIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBookIcon.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBookIcon.vue?vue&type=style&index=0&id=1c79732c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c79732c"]])

export default __exports__